<template>
  <div class="thousand_layout" v-loading="loading">
    <div class="">
      <div class="bids_tabs">
        <div @click="HistoryTabs(1)" :class="historyTab==1?'on':''">{{$t('base.unpaid')}}<span v-if="tabNumber[0]>0">({{tabNumber[0]}})</span></div>
        <div @click="HistoryTabs(2)" :class="historyTab==2?'on':''">{{$t('base.toBeShipped')}}<span v-if="tabNumber[1]>0">({{tabNumber[1]}})</span></div>
        <div @click="HistoryTabs(3)" :class="historyTab==3?'on':''">{{$t('base.shipped')}}<span v-if="tabNumber[2]>0">({{tabNumber[2]}})</span></div>
        <div @click="HistoryTabs(4)" :class="historyTab==4?'on':''">{{$t('base.dispute')}}<span v-if="tabNumber[3]>0">({{tabNumber[3]}})</span></div>
        <div @click="HistoryTabs(5)" :class="historyTab==5?'on':''">{{$t('base.toLeave')}}<span v-if="tabNumber[4]>0">({{tabNumber[4]}})</span>
        </div>
        <!-- <span v-if="tabNumber[5]>0">({{tabNumber[5]}})</span> -->
        <div @click="HistoryTabs(6)" :class="historyTab==6?'on':''">{{$t('base.completed')}}<span v-if="tabNumber[5]>0">({{tabNumber[5]}})</span></div>
      </div>
      <div>
        <el-form ref="historyForm" class="history_form" :model="form">
          <!--  @change="submitForm('historyForm')" -->
          <el-form-item class="history_form_item" :label="$t('base.title')">
            <el-input v-model="form.title" class="info_ipt" :placeholder="$t('base.itemTitle')"></el-input>
          </el-form-item>
          <el-form-item class="history_form_item" :label="$t('base.orderNum')">
            <el-input v-model="form.order" class="info_ipt" :placeholder="$t('base.orderNumber')"></el-input>
          </el-form-item>
          <el-form-item class="history_form_item" :label="$t('base.sellerName')">
            <el-input v-model="form.seller" class="info_ipt" :placeholder="$t('base.sellerName')"></el-input>
          </el-form-item>
          <el-button type="primary" class="history_form_btn" @click="submitForm('historyForm')">{{$t('base.search')}}</el-button>
        </el-form>
        <div>
          <div class="table_head">
            <div class="head_img head_box"></div>
            <div class="commod head_box">{{$t('base.item')}}</div>
            <div class="head_box itprice">{{$t('base.itemPrice')}}</div>
            <div class="head_box Quantity">{{$t('base.quantity')}}</div>
            <div class="head_box">{{$t('base.shippingFee')}}</div>
            <div class="head_box itprice">{{$t('base.orderTotal')}}</div>
            <div class="head_box tracking" v-if="historyTab!=4">{{$t('base.status')}}</div>
            <el-dropdown class="head_box tracking isArrived" @command="handleCommand" trigger="click" v-if="historyTab==4">
              <span class="el-dropdown-link">
                {{isArrived}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :class="arriveType==item.value?'on':''" v-for="(item,index) in arrived" :key="index" :command="item.value">
                  {{item.label}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="head_box tracking">
              {{$t('base.operate')}}
                <el-tooltip v-if="historyTab==3" :content="$t('alert.checkeFinish')" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </div>
          </div>
          <history-list :list="list" :type="historyTab" :arrived="isArrived" @getDialog="getDialog" />

        </div>
        <list-pagination class="pagination" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!ifData" />
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
        <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
      </div>
    </div>
  </div>
</template>
<script>
import NOTN from "@/components/notnull.vue";
import HistoryList from "@/components/list/history"
import ListPagination from '@/components/listpagination'
import FZF from "@/components/404.vue";

export default {
  name: 'tabslist',
  components: { ListPagination, HistoryList, NOTN, FZF },
  data() {
    return {
      loading: false,
      historyTab: 1,
      ifData: false,
      tabNumber: '',
      isArrived: 'All Status',
      list: {},
      arriveType:0,
      arrived: this.$enumInfo.arrived,
      pi: 1,
      ps: 60,
      TotalCount: 0,
      form: {
        title: '',
        order: '',
        seller: '',
      },
      resultTpye: '',
      pSRType: ''
    }
  },
  props: {
    userInfo: {}
  },
  mounted() { },
  created() {
    this.historyTab = this.$route.query.type || 1;
    this.GetBuyStatistics()
    this.GetSearchSell()
  },
  methods: {
    // 获取订单列表
    /**
     * 获取购买订单搜索结果
     * 根据用户信息和搜索条件查询购买订单列表
     * @description 发送请求获取订单数据,处理返回结果并更新组件状态
     * - 支持按订单号、卖家、商品标题搜索
     * - 处理不同订单类型(historyTab)的特殊逻辑
     * - 计算商品总数量
     * - 处理优惠券日期
     * - 更新列表数据和总数
     */
    GetSearchSell() {
      let that = this;
      this.loading = true;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, pageIndex: that.pi, pageSize: that.ps, BuyOrderType: that.historyTab, OrderNo: that.form.order, RealName: that.form.seller, CommodityTitle: that.form.title }
      if (this.historyTab == 4) {
        data.SRType = this.pSRType
      }
      
      //console.log(this.historyTab,'this.historyTab',this.pSRType,'this.pSRType',data.SRType,'data.SRType')
      //console.log(data)
      //console.log(this.$interface.SearchBuyOrders)
      //SRType
      this.$get(this.$interface.SearchBuyOrders, data).then(res => {
      //console.log(res)
        if (res.result != 0) {
          let result = res.data;
          try{
            result.map(it=>{
              it.Quantity=0
              it.Details.map(re=>{
                it.Quantity+=re.QuantitySold
              })
              it.isPickUp=false
              var isMemberSource='US,CN,MO,HK,TW'
              if(isMemberSource.indexOf(it.BuyerMemberSource)>-1&&isMemberSource.indexOf(it.SellMemberSource)>-1){
                if((it.BuyerMemberSource===it.SellMemberSource)||it.IsCustomAdress){
                  it.isPickUp=true
                }
              }
            })
          }catch(error){}
          // console.log(that.historyTab)
          // if (that.historyTab == 1) {
          //   result.map(e => {
          //     e.Remaining = new Date(new Date(e.CreateDate).getTime() + 72 * 60 * 60 * 1000)
          //   })
          // }
          if (that.historyTab == 2) {
            result.map(item => {
              let time = new Date(item.CreateDate).getTime() + 24 * 60 * 60 * 1000
              item.NewCouponDate = new Date(time)
            })
          }
          that.list = result;
          that.TotalCount = res.count;
          if(res.count == 0){
            this.ifData=true;
          }else{
            this.ifData=false
          }
        } else {
          this.ifData=true;
          that.list = null;
          that.TotalCount = 0
          this.loading = false
        }
        this.resultTpye = res.result
        this.loading = false
      })
    },

    // 获取订单统计
    /**
     * 获取用户购买统计数据
     * @description 通过用户ID和令牌获取购买相关的统计信息
     * @method GetBuyStatistics
     * @returns {Promise} 返回包含统计数据的Promise对象
     * @memberof purchase
     * @private
     */
    GetBuyStatistics() {
      let that = this
      let data = data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
      this.$get(this.$interface.GetBuyStatistics, data).then(res => {
        //console.log(res)
        if (res.result != 0) {
          let result = res.data;
          that.tabNumber = result
        }
      })
    },
    /**
     * 处理订单状态筛选命令
     * @param {string} val - 筛选状态值，可选值: 'All State'|'Disputing'|'Disputed'|'Revoke'
     * @description 根据选择的状态值设置对应的订单状态类型(pSRType)，并重新获取订单列表
     * - All State: 全部状态
     * - Disputing: 争议中(1)
     * - Disputed: 已争议(2)  
     * - Revoke: 已撤销(3)
     */
    handleCommand(val) {
      let that=this
      that.arriveType = val;
      //console.log(val,'val',this.isArrived,'this.isArrived ')
      switch (val) {
        case 0:
          that.pSRType = '';
          that.isArrived=that.$t('enum.allStatus')
          break;
        case 1:
        that.pSRType = 1;
          that.isArrived=that.$t('base.disputing')
          break;
        case 2:
        that.pSRType = 2;
          that.isArrived=that.$t('base.disputed')
          break;
        case 3:
        that.pSRType = 3;
          that.isArrived=that.$t('base.revoke')
          break;
      }
      this.GetSearchSell()
    },
    getDialog() {
      this.GetSearchSell()
      this.GetBuyStatistics()
    },
    //订单列表筛选
    submitForm() {
      this.GetSearchSell()
      this.GetBuyStatistics()
    },
    // tab
    HistoryTabs(val) {
      this.historyTab = val;
      this.form = {
        title: '',
        order: '',
        seller: '',
      }
      this.GetSearchSell();
      this.GetBuyStatistics()
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.GetSearchSell();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.GetSearchSell();
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/purchasehistory.css";

.pagination {
  margin-top: 20px;
}
.Quantity {
  width: 77px;
}
.isArrived {
  cursor: pointer;
}
.itprice {
  text-align: right;
}
.el-icon-question[data-v-0575cf1e] {
  color: #5f6dae;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/purchase.vue